import { Card, CardContent } from '@svs/ui/react/card';
import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponAdditionsContainerItemProps = PropsWithChildren<{
  title: string;
  description?: string;
  className?: string;
}>;

/**
 * Each coupon addition should be wrapped in this component to make sure correct sizing is applied
 * It renders a ui Card with the given title, description and children as content.
 *
 * @param root0 the input object
 * @param root0.children the content of this addition card
 * @param root0.className optional className for styling the card
 * @param root0.title title for the card
 * @param root0.description optional description of this card
 * @returns Component.
 */
export default function CouponAdditionsContainerItem({
  children,
  className,
  title,
  description,
}: CouponAdditionsContainerItemProps): ReactNode {
  return (
    <Card className={cn('bg-surface-standard w-full lg:w-full', className)}>
      <CardContent>
        <header className="pb-[6px]">
          <h3 className="flex justify-center text-lg font-medium lg:justify-start">{title}</h3>
          {description && (
            <div className="text-surface-fg-muted py-[6px] text-center text-sm lg:text-left">{description}</div>
          )}
        </header>
        {children}
      </CardContent>
    </Card>
  );
}
